import { z } from "zod";
import { i18nMessage } from "@/lib/i18nMessage";

export const registerLinkSchema = z.object({
  email: z
    .string({
      required_error: i18nMessage("shared:forms.registerLink.emailRequired"),
    })
    .email({ message: i18nMessage("shared:forms.registerLink.emailInvalid") }),
});

export type registerLinkFormData = z.infer<typeof registerLinkSchema>;
